(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyDetailController', CareTeamSpecialtyDetailController);

    CareTeamSpecialtyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CareTeamSpecialty', 'CareTeam', 'Corporation'];

    function CareTeamSpecialtyDetailController($scope, $rootScope, $stateParams, previousState, entity, CareTeamSpecialty, CareTeam, Corporation) {
        var vm = this;

        vm.careTeamSpecialty = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:careTeamSpecialtyUpdate', function(event, result) {
            vm.careTeamSpecialty = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
